(ns hai.ui.utils.debounce
  "Re-Frame debounce effects and events for dispatching and stopping debounced events/effects"
  (:require
   [hai.ui.rf-sugar :refer [>e defeffect defevent-fx]]))

(defonce timeouts (atom {}))

(defeffect :debounce/dispatch
  [{:keys [id event duration]}]
  (js/clearTimeout (get @timeouts id))
  (swap! timeouts assoc id
         (js/setTimeout
          (fn []
            (>e event)
            (swap! timeouts dissoc id))
          duration)))

(defevent-fx :debounce/dispatch
  [_ event]
  {:debounce/dispatch event})

(defeffect :debounce/stop
  [{:keys [id]}]
  (js/clearTimeout (get @timeouts id))
  (swap! timeouts dissoc id))

(defevent-fx :debounce/stop
  [_ event]
  {:debounce/stop event})
